import { render } from "./ChatMessageTime.vue?vue&type=template&id=108e2576"
import script from "./ChatMessageTime.vue?vue&type=script&lang=js"
export * from "./ChatMessageTime.vue?vue&type=script&lang=js"

import "./ChatMessageTime.vue?vue&type=style&index=0&id=108e2576&lang=scss"

import exportComponent from "/var/www/vimashenets/data/www/valera.report.tz365.ru/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__